<template>
            <tr class="font-costea text-t12 pb-3 h-14">
                <td>
                    <button @click="removeCif" class="mx-2 cursor-pointer bg-costeaContainer text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaSalmon rounded-full w-5 h-5 flex justify-center items-center"><i class="ri-close-fill"></i></button>
                </td>
                <td class=""><input v-model="nombreCosto" class="bg-white border-gray-200 border-2 w-full text-t14 font-costea text-costeaDarkGray py-2 px-2 rounded-md"/></td>
                <td class="text-right"><input v-model="costoMensual" class="bg-white border-gray-200 border-2 w-full rounded-md text-t14 font-costea text-costeaDarkGray py-2 px-2"/></td>
                <td>
                    <button @click="addCif" class="ring-4 ring-costeaPrimaryDisabled ring-opacity-30 mx-2 cursor-pointer bg-costeaPrimaryDisabled text-costeaPrimary hover:bg-costeaPrimary hover:text-white rounded-full w-5 h-5 flex justify-center items-center"><i class="ri-check-fill"></i></button>
                </td>
            </tr>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
export default {
    data(){
        return{
            nombreCosto: '',
            costoMensual: '',
            products: ''
        }
    },
    computed:{
        ...mapState(['costea']),
    },
    methods:{
        
        getProductById(){
            axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-view/${this.$route.params.id}`)
            .then(
            res =>{
                this.products = res.data.data
            })
            .catch(error => console.log(error))
        },
        addCif(){
            axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}cif-add`,
            {
            fecha_de_estudio: '2022-01-01',
            nombre_costo: this.nombreCosto,
            costo_mensual: this.costoMensual,
            }).then(response => {
                if(response.status === 200){
                    let cif = [response.data.success.CIFData.id]
                    let prod = this.products.cifcostos
                    for(var i=0; i < prod.length; i++){
                        cif.push(prod[i].cif_costo_id)
                    }
                    axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto/cif-add/${this.$route.params.id}`, {cif_costo_id: cif})
                    .then(
                        this.toggleModal(),
                        this.removeCif()
                    ).catch(error => console.log(error))
                }
            }
            ).catch(error => console.log(error))
        },
        removeCif(){
            this.$emit('removeCif', -1)
        },
        toggleModal(){
            this.$emit('reloadData', true)
        },
    },
    mounted(){
        this.getProductById()
    }
}
</script>

<style>

</style>